"use client";

export function AnimatedBackground() {
	return (
		<div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
			<div className="absolute top-20 left-10 w-72 h-72 bg-primary-200/20 dark:bg-primary-800/20 rounded-full blur-3xl animate-float"></div>
			<div className="absolute top-40 right-20 w-96 h-96 bg-teal-200/20 dark:bg-teal-800/20 rounded-full blur-3xl animate-float-slow" style={{ animationDelay: '1s' }}></div>
			<div className="absolute bottom-20 left-1/4 w-80 h-80 bg-primary-300/20 dark:bg-primary-700/20 rounded-full blur-3xl animate-float" style={{ animationDelay: '2s' }}></div>
		</div>
	);
}

